<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown
              [options]="occMapList"
              formControlName="occMapId"
              optionLabel="name"
              optionValue="occMapId"
              [filter]="true"
              filterPlaceholder="Search maps..."
              placeholder="Select Occ Map"
              inputId="occMapId">
            </p-dropdown>
            <label for="occMapId">Occ Map</label>

            @for (validation of validationMessages.occMapId; track validation) {
              <span>
                @if (form1.get('occMapId').hasError(validation.type) &&
                  (form1.get('occMapId').dirty || form1.get('occMapId').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="daysToArrivalTo" id="daysToArrivalTo" type="number" pInputText>
            <label for="daysToArrivalTo">Days To Arrival To (0-1000000)</label>
            @for (validation of validationMessages.daysToArrivalTo; track validation) {
              <span>
                @if (form1.get('daysToArrivalTo').hasError(validation.type) &&
                  (form1.get('daysToArrivalTo').dirty || form1.get('daysToArrivalTo').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="daysToArrivalFrom" id="daysToArrivalFrom" type="number" pInputText>
            <label for="daysToArrivalFrom">Days To Arrival From (0-1000000)</label>
            @for (validation of validationMessages.daysToArrivalFrom; track validation) {
              <span>
                @if (form1.get('daysToArrivalFrom').hasError(validation.type) &&
                  (form1.get('daysToArrivalFrom').dirty || form1.get('daysToArrivalFrom').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="expNominalOccToDatePct" id="expNominalOccToDatePct" type="number" pInputText
              min="0"
              max="100"
              step="1">
            <label for="expNominalOccToDatePct">Expected Nominal Occupancy % (0–100)</label>
            @for (validation of validationMessages.expNominalOccToDatePct; track validation) {
              <span>
                @if (form1.get('expNominalOccToDatePct').hasError(validation.type) &&
                  (form1.get('expNominalOccToDatePct').dirty || form1.get('expNominalOccToDatePct').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown
              [options]="seasonCodeList"
              formControlName="seasonCode"
              optionLabel="label"
              placeholder="Select Season Code"
              [filter]="true"
              appendTo="body"
              filterPlaceholder="Search...">
            </p-dropdown>
            <label for="seasonCode">Season Code</label>
            @for (validation of validationMessages.seasonCode; track validation) {
              <span>
                @if (form1.get('seasonCode').hasError(validation.type) &&
                  (form1.get('seasonCode').dirty || form1.get('seasonCode').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="minStayExpectedNTS" type="number" pInputText>
            <label>Min Stay Expected NTS</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <!-- min="-100": these multipliers can be negative; HTML min attr registers an Angular MinValidator -->
            <input formControlName="shortTermGapMultiplierPCT" type="number" min="-100" max="100" pInputText>
            <label>Short Term Gap Multiplier %</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="shortTermGapMinNumNightsRevNTS" type="number" pInputText>
            <label>Short Term Gap Min Nights Rev</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="longTermGapMultiplierPCT" type="number" min="-100" max="100" pInputText>
            <label>Long Term Gap Multiplier %</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="longTermGapEmptyMultiplierPCT" type="number" min="-100" max="100" pInputText>
            <label>Long Term Gap Empty Multiplier %</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="connectingFrontOrBackMultiplierPCT" type="number" min="-100" max="100" pInputText>
            <label>Connecting Front Or Back %</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="connectingFrontAndBackMultiplierPCT" type="number" min="-100" max="100" pInputText>
            <label>Connecting Front And Back %</label>
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (occMatrixId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>
            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              <!-- <button pButton *ngIf="!occMatrixId" class="btn-addt p-button" (click)="formAdd()">Add</button> -->
              @if (!occMatrixId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()" [disabled]="form1.invalid" >Add</button>
              }

              @if (occMatrixId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()" [disabled]="form1.invalid" >Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>